const semanticClassNames = {
  root: 'image',
} as const;

export default semanticClassNames;
